import {COMPANY} from './companyActionTypes';

export function getCompanies() {
  return {
    type: COMPANY.GET_COMPANIES,
    payload: {
      client: 'default',
      request: {
        url: `companies`,
        method: 'get'
      }
    }
  };
}
export function getCompany(id,signal) {
  return {
    type: COMPANY.GET_COMPANY,
    payload: {
      client: 'default',
      request: {
        url: `companies/${id}`,
        method: 'get',
        signal: signal
      }
    }
  };
}
export function getCompanyAvatars() {
  return {
    type: COMPANY.GET_COMPANY_AVATARS,
    payload: {
      client: 'default',
      request: {
        url: `companies/avatars`,
        method: 'get',
      }
    }
  };
}

export function getCompanyNotifications(companyId) {
  return {
    type: COMPANY.GET_COMPANY_NOTIFICATIONS,
    payload: {
      client: 'default',
      request: {
        url: `me/companies/${companyId}/notifications`,
        method: 'get'
      }
    }
  };
}

export function patchCompanyNotifications(data, companyId) {
  return {
    type: COMPANY.PATCH_COMPANY_NOTIFICATIONS,
    payload: {
      client: 'default',
      request: {
        url: `me/companies/${companyId}/notifications`,
        method: 'patch',
        data
      }
    }
  };
}

export function createCompany(data) {
  return {
    type: COMPANY.CREATE_COMPANY,
    payload: {
      client: 'default',
      request: {
        url: `companies`,
        method: 'post',
        data
      }
    }
  };
}

export function editCompany(data, id) {
  return {
    type: COMPANY.EDIT_COMPANY,
    payload: {
      client: 'default',
      request: {
        url: `companies/${id}`,
        method: 'post',
        data
      }
    }
  };
}

export function resetCompany() {
  return {
    type: COMPANY.RESET_COMPANY,
    payload: {}
  };
}
